import { inject, injectable } from "inversify";
import { IUserPreferencesGateway } from "../ports/UserPreferencesGateway";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import {
  IPreferencesUser,
  IViewContextUserPreferences
} from "@/features/financas/views/Indicadores/@types/type";
import { IGetResponseBase } from "@/features/financas/views/Indicadores/services/types";
import { IUserPreferences } from "@/store/shared/userPreferences/types";

@injectable()
export default class UserPreferencesGatewayAdapter
  implements IUserPreferencesGateway
{
  @inject(DITypes.HORIZONS_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async getUserPreferences(
    params: IViewContextUserPreferences
  ): Promise<IPreferencesUser[] | undefined> {
    const response = await this.httpClient.get<
      IGetResponseBase<IPreferencesUser[] | undefined>
    >({
      url: "/lista-preferencias-usuario",
      queryParams: {
        ...params
      }
    });

    if (response.body?.code !== 200) return [];

    return response.body?.result;
  }

  async deleteUserPreferences(id: string): Promise<boolean | undefined> {
    const response = await this.httpClient.delete<
      IGetResponseBase<IUserPreferences[] | null | undefined>
    >({
      url: "/deleta-preferencia-usuario",
      params: {
        userPreferenceId: id
      }
    });

    return response.body?.code == 200;
  }

  async salvarUserPreferences(
    params: IPreferencesUser
  ): Promise<boolean | undefined> {
    const response = await this.httpClient.post<
      IGetResponseBase<IUserPreferences[] | null | undefined>
    >({
      url: "/salva-preferencia-usuario",
      body: { ...params }
    });

    return response.body?.code == 200;
  }
}
